import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { isFemale, unixFromNow, perPageContactLog } from '../../../utils'

const CONSTELLATIONS = ['水瓶座', '双鱼座', '白羊座', '金牛座', '双子座', '巨蟹座', '狮子座', '处女座', '天秤座', '天蝎座', '射手座', '魔羯座']

function getDateTime (time) {
  const date = new Date(time)
  const y = date.getFullYear()
  const m = date.getMonth() + 1
  const d = date.getDate()
  return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + date.toTimeString().substr(0, 8)
}

/*
const sampleContact = {
  phone: '12312341234',
  mail: '21213dwa@wxh.com',
  address: '北京葫芦屯大院',

  info: {
    org: '某科学的机构',
    categories: [
      { text: '志愿者', path: '/main/contact/tag' },
      { text: '爱猫小能手', path: '/main/contact/tag' }
    ],
    tags: [
      { text: '2016年', color: '#ff6743', path: '/main/contact/tag' },
      { text: '我和', color: '#50d2c2', path: '/main/contact/tag' },
      { text: '席某某', color: '#ffb258', path: '/main/contact/tag' },
      { text: '一起', color: '#938ef7', path: '/main/contact/tag' },
      { text: '放鸽子', color: '#50d2c2', path: '/main/contact/tag' },
      { text: '鸽子', color: '#ff6743', path: '/main/contact/tag' },
      { text: '子', color: '#ffb258', path: '/main/contact/tag' }
    ],
    numRemarks: 233,
    numAttachments: 1234,
    size: '男 M码'
  },

  log: {
    countFormSubmits: 12,
    formSubmits: [
      { name: '无敌小UU的报名', value: '今天19:35' },
      { name: '无敌小UU的报名', value: '昨天19:35' },
      { name: '无敌小UU的报名', value: '昨天19:35' },
      { name: '无敌小UU的报名', value: '2016.2.14' }
    ],

    countCfSubmits: 14,
    sumCf: 987654.123,
    cfSubmits: [
      { name: '无敌小UU的报名实验', value: '12345.344' },
      { name: '无敌小UU的报名实验', value: '1324.324' },
      { name: '无敌小UU的报名实验', value: '1324.324' },
      { name: '无敌小UU的报名实验', value: '1324.324' },
      { name: '无敌小UU的报名实验', value: '1324.324' },
      { name: '无敌小UU的报名实验', value: '1324.324' },
      { name: '无敌小UU的报名实验', value: '1324.324' },
      { name: '无敌小UU的报名实验', value: '1324.324' }
    ]
  }
}
*/

const state = {
  name: '',
  avatar: '',
  isFemale: false,

  phone: null,
  phone2: null,
  mail: null,
  mail2: null,
  address: null,

  info: {
    org: '',
    categories: [],
    tags: [],
    size: '',
    others: [],
    statistics: []
  },

  numRemarks: 0,
  numAttachments: 0,

  log: {
    formfill: {
      count: 0,
      list: [],
      currentPage: 1,
      hasMore: true
    },
    signup: {
      count: 0,
      list: [],
      currentPage: 1,
      hasMore: true
    },
    donate: {
      count: 0,
      sum: 0,
      list: [],
      currentPage: 1,
      hasMore: true
    }
  }
}

const actions = {
  [aTypes.CONTACT_GET_CONTACT] ({ commit }, id) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT, loading: true })
    api.contact.getContact({
      success (res) {
        const data = res.body
        const contact = {
          name: data.name,
          avatar: data.avatar,
          isFemale: isFemale(data.gender),
          phone: data.mobile || data.mobile2,
          phone2: data.mobile2,
          mail: data.email || data.email2,
          mail2: data.email2,
          address: data.address,
          info: {
            org: data.org || {},
            categories: data.roles ? data.roles.map(role => {
              return {
                text: role.display_name,
                to: {
                  path: '/main/contact',
                  query: {
                    roleId: role.id,
                    tagName: role.display_name
                  }
                }
              }
            }) : [],
            tags: data.tags ? data.tags.map(tag => {
              return {
                text: tag.name,
                color: tag.rgb,
                to: {
                  path: '/main/contact',
                  query: {
                    tagId: tag.id,
                    tagName: tag.name,
                    tagColor: tag.rgb
                  }
                }
              }
            }) : [],
            size: '',
            others: [],
            statistics: []
          }
          /*
          log: {
            countFormSubmits: data.formfills ? data.formfills.length : 0,
            formSubmits: data.formfills ? data.formfills.map(f => {
              return {
                id: f.id,
                name: f.form.title,
                value: unixFromNow(f.create_time)
              }
            }) : [],

            countCfSubmits: data.donates ? data.donates.length : 0,
            sumCf: data.donates ? data.donates.reduce((acc, cur) => acc + cur.donate_amount, 0) : 0,
            cfSubmits: data.donates ? data.donates.map(f => {
              return {
                id: f.id,
                name: f.project_title,
                value: f.donate_amount
              }
            }) : []
          }
          */
        }
        const othersMap = {
          // '出生日期': data => { return data.birthday },
          // '星座': data => { return CONSTELLATIONS[data.constellation - 1] },
          // '性别': data => { return data.gender },
          // '身份证': data => { return data.identity_id },
          // '编号': data => { return data.member },
          // '单位职务': data => { return data.org_position },
          // '所在部门': data => { return data.org_department },
        }

        if (data.hasOwnProperty('constellation') && data.constellation >= 1 && data.constellation <= 12) {
          data.constellation = CONSTELLATIONS[data.constellation - 1]
        }
        if (data.hasOwnProperty('create_time')) {
          data.create_time = getDateTime(data.create_time * 1000)
        }
        if (data.hasOwnProperty('update_time')) {
          data.update_time = getDateTime(data.update_time * 1000)
        }

        // 其他信息列
        for (const key in data.other_columns) {
          othersMap[key] = data => {
            return data[data.other_columns[key]]
          }
        }

        // 拓展列
        for (const key in data.metas) {
          othersMap[key] = data => {
            return data.metas[key]
          }
        }

        for (const key in othersMap) {
          const value = othersMap[key](data)
          if (value && value !== '0.00') {
            contact.info.others.push({
              key: {
                text: key
              },
              value
            })
          }
        }

        const statisticsMap = {

        }
        // 其他信息列
        for (const key in data.statistics_columns) {
          statisticsMap[key] = data => {
            return data[data.statistics_columns[key]]
          }
        }
        for (const key in statisticsMap) {
          const value = statisticsMap[key](data)
          if (value && value !== '0.00') {
            contact.info.statistics.push({
              key: {
                text: key
              },
              value
            })
          }
        }

        commit(mTypes.CONTACT_SET_CONTACT, contact)
        commit(mTypes.SET_NAV_TITLE, contact.name)
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT, loading: false })
      },
      commit
    }, id)

    api.contact.getContactNoteStat({
      success (res) {
        const body = res.body
        const contact = {
          numRemarks: body.data.count
        }
        commit(mTypes.CONTACT_SET_CONTACT, contact)
      },
      commit
    }, id)

    api.contact.getContactAttachmentStat({
      success (res) {
        const body = res.body
        const contact = {
          numAttachments: body.data.count
        }
        commit(mTypes.CONTACT_SET_CONTACT, contact)
      },
      commit
    }, id)
  },
  [aTypes.CONTACT_GET_CONTACT_FORMFILLS] ({ commit }, { id, page, append }) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_FORMFILLS, loading: true })
    api.contact.getContactFormfills({
      success (res) {
        const body = res.body
        const pagination = body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.CONTACT_SET_CONTACT_FORMFILLS, {
          count: body.meta.pagination.total,
          list: body.data.map(f => {
            return {
              id: f.id,
              name: f.form.title,
              value: unixFromNow(f.create_time),
              enable_private_form: f.form.enable_private_form
            }
          }),
          page,
          hasMore,
          append
        })
        commit(mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_FORMFILL, id)
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_FORMFILLS, loading: false })
      },
      commit
    }, { id, page, perPage: perPageContactLog })
  },
  [aTypes.CONTACT_GET_CONTACT_SIGNUPS] ({ commit }, { id, page, append }) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_SIGNUPS, loading: true })
    api.contact.getContactSignups({
      success (res) {
        const body = res.body
        const pagination = body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.CONTACT_SET_CONTACT_SIGNUPS, {
          count: body.meta.pagination.total,
          list: body.data.map(f => {
            return {
              id: f.id,
              name: f.activity.title,
              value: unixFromNow(f.created_at)
            }
          }),
          page,
          hasMore,
          append
        })
        commit(mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_SIGNUP, id)
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_SIGNUPS, loading: false })
      },
      commit
    }, { id, page, perPage: perPageContactLog })
  },
  [aTypes.CONTACT_GET_CONTACT_DONATES] ({ commit }, { id, page, append }) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_DONATES, loading: true })
    api.contact.getContactDonates({
      success (res) {
        const body = res.body
        const pagination = body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.CONTACT_SET_CONTACT_DONATES, {
          count: body.meta.pagination.total,
          list: body.data.map(f => {
            return {
              id: f.id,
              name: f.project.title,
              value: f.donate_amount
            }
          }),
          page,
          hasMore,
          append
        })
        commit(mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_DONATE, id)
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_DONATES, loading: false })
      },
      commit
    }, { id, page, perPage: perPageContactLog })
  },
  [aTypes.CONTACT_GET_CONTACT_DONATE_STAT] ({ commit }, id) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_DONATE_STAT, loading: true })
    api.contact.getContactDonateStat({
      success (res) {
        commit(mTypes.CONTACT_SET_CONTACT_DONATE_STAT, {
          sum: res.body.sum_donate_amount
        })
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_CONTACT_DONATE_STAT, loading: false })
      },
      commit
    }, id)
  }
}

const mutations = {
  [mTypes.CONTACT_SET_CONTACT] (state, payload) {
    for (const key in payload) {
      if (state.hasOwnProperty(key)) {
        state[key] = payload[key]
      }
    }
  },
  [mTypes.CONTACT_SET_CONTACT_FORMFILLS] (state, { count, list, page, hasMore, append }) {
    state.log.formfill.count = count
    state.log.formfill.currentPage = page
    state.log.formfill.hasMore = hasMore
    if (append) {
      state.log.formfill.list = state.log.formfill.list.concat(list)
    } else {
      state.log.formfill.list = list
    }
  },
  [mTypes.CONTACT_SET_CONTACT_SIGNUPS] (state, { count, list, page, hasMore, append }) {
    state.log.signup.count = count
    state.log.signup.currentPage = page
    state.log.signup.hasMore = hasMore
    if (append) {
      state.log.signup.list = state.log.signup.list.concat(list)
    } else {
      state.log.signup.list = list
    }
  },
  [mTypes.CONTACT_SET_CONTACT_DONATES] (state, { count, list, page, hasMore, append }) {
    state.log.donate.count = count
    state.log.donate.currentPage = page
    state.log.donate.hasMore = hasMore
    if (append) {
      state.log.donate.list = state.log.donate.list.concat(list)
    } else {
      state.log.donate.list = list
    }
  },
  [mTypes.CONTACT_SET_CONTACT_DONATE_STAT] (state, { sum }) {
    state.log.donate.sum = sum
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/contact.js